/*
  Urgency Countdown

  Writes "3d 5h 44m 12s" into [data-countdown] and removes itself once
  the deadline passes. Mirrors countdown-timer.js.

  Usage:
    <urgency-countdown :date="2026-06-15 23:59:59">
      <span>Ends in</span>
      <span data-countdown></span>
    </urgency-countdown>
*/

class UrgencyCountdown extends CustomElement {
  props = {
    date: "",
  };

  SECONDS_PER_MINUTE = 60;
  SECONDS_PER_HOUR = 60 * this.SECONDS_PER_MINUTE; // 3,600
  SECONDS_PER_DAY = 24 * this.SECONDS_PER_HOUR; // 86,400

  constructor() {
    super();
  }

  mounted() {
    super.mounted();

    const { date } = this.props;
    const endTime = new Date(date.replace(" ", "T"));
    const delta = (endTime - Date.now()) / 1000;

    this.$output = this.$el.find("[data-countdown]");

    this.tick(delta);
  }

  tick(delta) {
    if (!delta || delta < 0) {
      this.$el.remove();
      return;
    }

    this.$output.text(this.format(delta));

    setTimeout(() => this.tick(delta - 1), 1000);
  }

  format(delta) {
    const days = Math.floor(delta / this.SECONDS_PER_DAY);
    delta -= days * this.SECONDS_PER_DAY;

    const hours = Math.floor(delta / this.SECONDS_PER_HOUR);
    delta -= hours * this.SECONDS_PER_HOUR;

    const minutes = Math.floor(delta / this.SECONDS_PER_MINUTE);
    delta -= minutes * this.SECONDS_PER_MINUTE;

    const seconds = Math.floor(delta);

    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }
}

customElements.define("urgency-countdown", UrgencyCountdown);
